export default function Positioning() {
  return (
    <section data-testid="positioning-section" className="py-24 md:py-32 bg-[#F8F5EF] relative overflow-hidden">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* LEFT: Editorial typography */}
          <div className="lg:col-span-6 reveal">
            <div className="overline mb-8">
              Visuelle Vermarktung · NRW
            </div>

            <h2 className="font-display text-[44px] sm:text-6xl lg:text-[80px] leading-[1.0] tracking-[-0.015em] text-[#1A1A1A] font-light">
              Nicht nur <br />
              schöne Bilder.<br />
              <span className="italic font-normal gold-text">Visueller Content,</span><br />
              der verkauft.
            </h2>

            <p className="mt-10 max-w-xl text-[16px] md:text-[18px] leading-[1.65] text-[#3A3A3A] font-light">
              Wertbild ist spezialisiert auf professionelle Immobilien- und
              Architekturfotografie, Drohnenbilder, 3D-Touren, Immobilien&shy;videos
              und Virtual Staging. Der Fokus liegt auf realistischen,
              verkaufsstarken Bildern, die Vertrauen schaffen.
            </p>

            <div className="mt-12 inline-flex items-baseline gap-5">
              <span className="ticker-num text-7xl text-[#FFA500]">7+</span>
              <span className="text-sm text-[#5A5A5A] font-light max-w-[18ch] leading-tight">
                Jahre Erfahrung in Immobilien & Vermarktung
              </span>
            </div>
          </div>

          {/* RIGHT: Offset image composition (from screenshot 2 design) */}
          <div className="lg:col-span-6 relative reveal">
            <div className="relative h-[70vh] md:h-[82vh]">
              {/* Main image */}
              <div className="img-hover absolute top-0 right-0 w-[88%] h-[82%] overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1622015663381-d2e05ae91b72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yfGVufDB8fHx8MTc3ODU5NjkzOHww&ixlib=rb-4.1.0&q=85"
                  alt="Premium Architektur"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Offset secondary image */}
              <div className="img-hover absolute bottom-0 left-0 w-[52%] h-[42%] overflow-hidden border-[10px] border-[#F8F5EF] shadow-[0_28px_72px_-20px_rgba(0,0,0,0.4)]">
                <img
                  src="https://images.unsplash.com/photo-1758448756084-c44d73014c07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwZWxlZ2FudCUyMGJyaWdodCUyMGludGVyaW9yfGVufDB8fHx8MTc3ODU5Njk0Mnww&ixlib=rb-4.1.0&q=85"
                  alt="Interior Detail"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
